window.addEventListener('load', function() {

	var els = document.querySelectorAll('.lightbox');
	var lightbox = document.getElementById('lightbox');
	var lightboxClose = document.getElementById('lightbox-close');
	var lightboxImg = document.getElementById('lightbox-img');

	for (var i = 0; els.length > i; i++) {
		els[i].addEventListener('click', function() {
			lightbox.classList.add('active');
			var src = this.src;
			var alt = this.alt;
			lightboxImg.src = src;
			lightboxImg.alt = alt;
			lightboxClose.focus();
		});
	}

	lightboxClose.addEventListener('click', function() {
		lightbox.classList.remove('active');
	});
	
	lightbox.addEventListener('click', function(e) {
		if ( e.target == lightbox ) {
			lightbox.classList.remove('active');
		}
	});

	// Close modal on escape
	document.addEventListener( 'keyup', function(e) {
		if ( e.key === "Escape" ) {
			lightbox.classList.remove('active');
		}
	});
});